import type { StudentPortfolioAssignmentResource } from "api/generated";
import type { StudentAssignment, StudentAssignmentMeta } from "portfolio/types";
import { studentAssessmentFromDto } from "./assessment.mapper";
import { portfolioStudentTaskFromDto } from "./portfolioTask.mapper";
import { shallowActivityFromDto } from "./shallowActivity.mapper";
import { questionAnswerFromDto } from "./questionAnswer.mapper";

const mapAssignmentMeta = (
  resource: StudentPortfolioAssignmentResource,
): StudentAssignmentMeta => ({
  allowCreate: resource.meta.allow_create,
  allowEdit: resource.meta.allow_edit,
  allowRetry: resource.meta.allow_retry,
});

export const studentAssignmentFromDto = (
  resource: StudentPortfolioAssignmentResource,
): StudentAssignment => ({
  id: resource.id,
  task: portfolioStudentTaskFromDto(resource.task),
  activity: resource.activity
    ? shallowActivityFromDto(resource.activity)
    : null,
  ...(resource?.question_answers && {
    questionAnswers: resource.question_answers.map(questionAnswerFromDto),
  }),
  assessmentStatus: resource.assessment_status,
  status: resource.status,
  concept: resource.concept,
  gradeValue: resource.grade_value ?? null,
  assessments: resource.assessments.map(studentAssessmentFromDto),
  allowRetry: resource.allow_retry,
  submittedAt: resource.submitted_at ? new Date(resource.submitted_at) : null,
  completedAt: resource.completed_at ? new Date(resource.completed_at) : null,
  meta: mapAssignmentMeta(resource),
});
